import {
  Box,
  Breadcrumbs,
  CircularProgress,
  Stack,
  Typography,
} from "@mui/material";
import React, { useEffect } from "react";
import { useState, useRef } from "react";
import CustomeSurendra from "./Date";
import axios from "axios";
import BaseUrl from "../BaseUrl";
import StackedChart from "./StackedChart";
import { useLocation } from "react-router-dom";
import { DateRangePicker } from "rsuite";
import Tooltip from "@mui/material/Tooltip";
import { useHistory } from "react-router-dom";
import Loader from "../Loader";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
const actionsArr = [
  // {
  //   id: 1,
  //   text: "Resume",
  //   svg: (
  //     <svg
  //       xmlns="http://www.w3.org/2000/svg"
  //       width="20"
  //       height="24"
  //       viewBox="0 0 24 25"
  //       fill="none"
  //     >
  //       <path
  //         d="M11.9688 22.9607C17.4916 22.9607 21.9688 18.4835 21.9688 12.9607C21.9688 7.43785 17.4916 2.96069 11.9688 2.96069C6.4459 2.96069 1.96875 7.43785 1.96875 12.9607C1.96875 18.4835 6.4459 22.9607 11.9688 22.9607Z"
  //         stroke="#1C485F"
  //         stroke-width="1.5"
  //         stroke-linecap="round"
  //         stroke-linejoin="round"
  //       />
  //       <path
  //         d="M8.74219 13.1907V11.5207C8.74219 9.4407 10.2122 8.5907 12.0122 9.6307L13.4622 10.4707L14.9122 11.3107C16.7122 12.3507 16.7122 14.0507 14.9122 15.0907L13.4622 15.9307L12.0122 16.7707C10.2122 17.8107 8.74219 16.9607 8.74219 14.8807V13.1907Z"
  //         stroke="#1C485F"
  //         stroke-width="1.5"
  //         stroke-miterlimit="10"
  //         stroke-linecap="round"
  //         stroke-linejoin="round"
  //       />
  //     </svg>
  //   ),
  // },
  {
    id: 2,
    text: "Edit",
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="24"
        viewBox="0 0 24 25"
        fill="none"
      >
        <path
          d="M11 2.96069H9C4 2.96069 2 4.96069 2 9.96069V15.9607C2 20.9607 4 22.9607 9 22.9607H15C20 22.9607 22 20.9607 22 15.9607V13.9607"
          stroke="#1C485F"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M16.0379 3.9807L8.15793 11.8607C7.85793 12.1607 7.55793 12.7507 7.49793 13.1807L7.06793 16.1907C6.90793 17.2807 7.67793 18.0407 8.76793 17.8907L11.7779 17.4607C12.1979 17.4007 12.7879 17.1007 13.0979 16.8007L20.9779 8.9207C22.3379 7.5607 22.9779 5.9807 20.9779 3.9807C18.9779 1.9807 17.3979 2.6207 16.0379 3.9807Z"
          stroke="#1C485F"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M14.9062 5.11072C15.5763 7.50072 17.4463 9.37072 19.8463 10.0507"
          stroke="#1C485F"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    ),
  },
  // {
  //   id: 3,
  //   text: "Complete",
  //   svg: (
  //     <svg
  //       xmlns="http://www.w3.org/2000/svg"
  //       width="20"
  //       height="24"
  //       viewBox="0 0 24 25"
  //       fill="none"
  //     >
  //       <path
  //         d="M11.9688 22.9607C17.4916 22.9607 21.9688 18.4835 21.9688 12.9607C21.9688 7.43785 17.4916 2.96069 11.9688 2.96069C6.4459 2.96069 1.96875 7.43785 1.96875 12.9607C1.96875 18.4835 6.4459 22.9607 11.9688 22.9607Z"
  //         stroke="#1C485F"
  //         stroke-width="1.5"
  //         stroke-linecap="round"
  //         stroke-linejoin="round"
  //       />
  //       <path
  //         d="M10.7334 17.1907H13.2734C15.3934 17.1907 16.2334 16.3407 16.2334 14.2307V11.6907C16.2334 9.57071 15.3834 8.73071 13.2734 8.73071H10.7334C8.61344 8.73071 7.77344 9.58071 7.77344 11.6907V14.2307C7.77344 16.3407 8.62344 17.1907 10.7334 17.1907Z"
  //         stroke="#1C485F"
  //         stroke-width="1.5"
  //         stroke-linecap="round"
  //         stroke-linejoin="round"
  //       />
  //     </svg>
  //   ),
  // },
];

const multipleOptions = [
  {
    id: 1,
    text: "Statistics",
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="22"
        height="20"
        viewBox="0 0 24 25"
        fill="none"
      >
        <path
          d="M6.88281 19.1106V17.0406"
          stroke="#727272"
          stroke-width="1.5"
          stroke-linecap="round"
        />
        <path
          d="M12 19.1107V14.9707"
          stroke="#727272"
          stroke-width="1.5"
          stroke-linecap="round"
        />
        <path
          d="M17.1172 19.1107V12.8907"
          stroke="#727272"
          stroke-width="1.5"
          stroke-linecap="round"
        />
        <path
          d="M17.1228 6.81067L16.6628 7.35067C14.1128 10.3307 10.6928 12.4407 6.88281 13.3907"
          stroke="#727272"
          stroke-width="1.5"
          stroke-linecap="round"
        />
        <path
          d="M14.1875 6.81067H17.1175V9.73067"
          stroke="#727272"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M9 22.9607H15C20 22.9607 22 20.9607 22 15.9607V9.96069C22 4.96069 20 2.96069 15 2.96069H9C4 2.96069 2 4.96069 2 9.96069V15.9607C2 20.9607 4 22.9607 9 22.9607Z"
          stroke="#727272"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    ),
    activeSvg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="22"
        height="20"
        viewBox="0 0 24 25"
        fill="none"
      >
        <path
          d="M6.88281 19.1106V17.0406"
          stroke="#1C485F"
          stroke-width="1.5"
          stroke-linecap="round"
        />
        <path
          d="M12 19.1107V14.9707"
          stroke="#1C485F"
          stroke-width="1.5"
          stroke-linecap="round"
        />
        <path
          d="M17.1172 19.1107V12.8907"
          stroke="#1C485F"
          stroke-width="1.5"
          stroke-linecap="round"
        />
        <path
          d="M17.1228 6.81067L16.6628 7.35067C14.1128 10.3307 10.6928 12.4407 6.88281 13.3907"
          stroke="#1C485F"
          stroke-width="1.5"
          stroke-linecap="round"
        />
        <path
          d="M14.1875 6.81067H17.1175V9.73067"
          stroke="#1C485F"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M9 22.9607H15C20 22.9607 22 20.9607 22 15.9607V9.96069C22 4.96069 20 2.96069 15 2.96069H9C4 2.96069 2 4.96069 2 9.96069V15.9607C2 20.9607 4 22.9607 9 22.9607Z"
          stroke="#1C485F"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    ),
  },
  // {
  //   id: 2,
  //   text: "Overview",
  //   svg: (
  //     <svg
  //       xmlns="http://www.w3.org/2000/svg"
  //       width="22"
  //       height="20"
  //       viewBox="0 0 24 25"
  //       fill="none"
  //     >
  //       <path
  //         d="M22 9.23069V5.19069C22 3.60069 21.36 2.96069 19.77 2.96069H15.73C14.14 2.96069 13.5 3.60069 13.5 5.19069V9.23069C13.5 10.8207 14.14 11.4607 15.73 11.4607H19.77C21.36 11.4607 22 10.8207 22 9.23069Z"
  //         stroke="#727272"
  //         stroke-width="1.5"
  //         stroke-linecap="round"
  //         stroke-linejoin="round"
  //       />
  //       <path
  //         d="M10.5 9.48069V4.94069C10.5 3.53069 9.86 2.96069 8.27 2.96069H4.23C2.64 2.96069 2 3.53069 2 4.94069V9.47069C2 10.8907 2.64 11.4507 4.23 11.4507H8.27C9.86 11.4607 10.5 10.8907 10.5 9.48069Z"
  //         stroke="#727272"
  //         stroke-width="1.5"
  //         stroke-linecap="round"
  //         stroke-linejoin="round"
  //       />
  //       <path
  //         d="M10.5 20.7307V16.6907C10.5 15.1007 9.86 14.4607 8.27 14.4607H4.23C2.64 14.4607 2 15.1007 2 16.6907V20.7307C2 22.3207 2.64 22.9607 4.23 22.9607H8.27C9.86 22.9607 10.5 22.3207 10.5 20.7307Z"
  //         stroke="#727272"
  //         stroke-width="1.5"
  //         stroke-linecap="round"
  //         stroke-linejoin="round"
  //       />
  //       <path
  //         d="M15 16.4607H21"
  //         stroke="#727272"
  //         stroke-width="1.5"
  //         stroke-linecap="round"
  //       />
  //       <path
  //         d="M15 20.4607H21"
  //         stroke="#727272"
  //         stroke-width="1.5"
  //         stroke-linecap="round"
  //       />
  //     </svg>
  //   ),
  //   activeSvg: (
  //     <svg
  //       xmlns="http://www.w3.org/2000/svg"
  //       width="22"
  //       height="20"
  //       viewBox="0 0 24 25"
  //       fill="none"
  //     >
  //       <path
  //         d="M22 9.23069V5.19069C22 3.60069 21.36 2.96069 19.77 2.96069H15.73C14.14 2.96069 13.5 3.60069 13.5 5.19069V9.23069C13.5 10.8207 14.14 11.4607 15.73 11.4607H19.77C21.36 11.4607 22 10.8207 22 9.23069Z"
  //         stroke="#1C485F"
  //         stroke-width="1.5"
  //         stroke-linecap="round"
  //         stroke-linejoin="round"
  //       />
  //       <path
  //         d="M10.5 9.48069V4.94069C10.5 3.53069 9.86 2.96069 8.27 2.96069H4.23C2.64 2.96069 2 3.53069 2 4.94069V9.47069C2 10.8907 2.64 11.4507 4.23 11.4507H8.27C9.86 11.4607 10.5 10.8907 10.5 9.48069Z"
  //         stroke="#1C485F"
  //         stroke-width="1.5"
  //         stroke-linecap="round"
  //         stroke-linejoin="round"
  //       />
  //       <path
  //         d="M10.5 20.7307V16.6907C10.5 15.1007 9.86 14.4607 8.27 14.4607H4.23C2.64 14.4607 2 15.1007 2 16.6907V20.7307C2 22.3207 2.64 22.9607 4.23 22.9607H8.27C9.86 22.9607 10.5 22.3207 10.5 20.7307Z"
  //         stroke="#1C485F"
  //         stroke-width="1.5"
  //         stroke-linecap="round"
  //         stroke-linejoin="round"
  //       />
  //       <path
  //         d="M15 16.4607H21"
  //         stroke="#1C485F"
  //         stroke-width="1.5"
  //         stroke-linecap="round"
  //       />
  //       <path
  //         d="M15 20.4607H21"
  //         stroke="#1C485F"
  //         stroke-width="1.5"
  //         stroke-linecap="round"
  //       />
  //     </svg>
  //   ),
  // },
  // {
  //   id: 3,
  //   text: "Recipients",
  //   svg: (
  //     <svg
  //       xmlns="http://www.w3.org/2000/svg"
  //       width="22"
  //       height="20"
  //       viewBox="0 0 23 25"
  //       fill="none"
  //     >
  //       <path
  //         d="M8.77552 11.8307C8.67969 11.8207 8.56469 11.8207 8.45927 11.8307C6.17844 11.7507 4.36719 9.80069 4.36719 7.40069C4.36719 4.95069 6.26469 2.96069 8.62219 2.96069C10.9701 2.96069 12.8772 4.95069 12.8772 7.40069C12.8676 9.80069 11.0564 11.7507 8.77552 11.8307Z"
  //         stroke="#727272"
  //         stroke-width="1.5"
  //         stroke-linecap="round"
  //         stroke-linejoin="round"
  //       />
  //       <path
  //         d="M15.7261 4.96069C17.5853 4.96069 19.0803 6.53069 19.0803 8.46069C19.0803 10.3507 17.6428 11.8907 15.8507 11.9607C15.7741 11.9507 15.6878 11.9507 15.6016 11.9607"
  //         stroke="#727272"
  //         stroke-width="1.5"
  //         stroke-linecap="round"
  //         stroke-linejoin="round"
  //       />
  //       <path
  //         d="M3.98938 15.5207C1.67021 17.1407 1.67021 19.7807 3.98938 21.3907C6.62479 23.2307 10.9469 23.2307 13.5823 21.3907C15.9015 19.7707 15.9015 17.1307 13.5823 15.5207C10.9565 13.6907 6.63437 13.6907 3.98938 15.5207Z"
  //         stroke="#727272"
  //         stroke-width="1.5"
  //         stroke-linecap="round"
  //         stroke-linejoin="round"
  //       />
  //       <path
  //         d="M17.5781 20.9607C18.2681 20.8107 18.9198 20.5207 19.4565 20.0907C20.9515 18.9207 20.9515 16.9907 19.4565 15.8207C18.9294 15.4007 18.2873 15.1207 17.6069 14.9607"
  //         stroke="#727272"
  //         stroke-width="1.5"
  //         stroke-linecap="round"
  //         stroke-linejoin="round"
  //       />
  //     </svg>
  //   ),
  //   activeSvg: (
  //     <svg
  //       xmlns="http://www.w3.org/2000/svg"
  //       width="22"
  //       height="20"
  //       viewBox="0 0 23 25"
  //       fill="none"
  //     >
  //       <path
  //         d="M8.77552 11.8307C8.67969 11.8207 8.56469 11.8207 8.45927 11.8307C6.17844 11.7507 4.36719 9.80069 4.36719 7.40069C4.36719 4.95069 6.26469 2.96069 8.62219 2.96069C10.9701 2.96069 12.8772 4.95069 12.8772 7.40069C12.8676 9.80069 11.0564 11.7507 8.77552 11.8307Z"
  //         stroke="#1C485F"
  //         stroke-width="1.5"
  //         stroke-linecap="round"
  //         stroke-linejoin="round"
  //       />
  //       <path
  //         d="M15.7261 4.96069C17.5853 4.96069 19.0803 6.53069 19.0803 8.46069C19.0803 10.3507 17.6428 11.8907 15.8507 11.9607C15.7741 11.9507 15.6878 11.9507 15.6016 11.9607"
  //         stroke="#1C485F"
  //         stroke-width="1.5"
  //         stroke-linecap="round"
  //         stroke-linejoin="round"
  //       />
  //       <path
  //         d="M3.98938 15.5207C1.67021 17.1407 1.67021 19.7807 3.98938 21.3907C6.62479 23.2307 10.9469 23.2307 13.5823 21.3907C15.9015 19.7707 15.9015 17.1307 13.5823 15.5207C10.9565 13.6907 6.63437 13.6907 3.98938 15.5207Z"
  //         stroke="#1C485F"
  //         stroke-width="1.5"
  //         stroke-linecap="round"
  //         stroke-linejoin="round"
  //       />
  //       <path
  //         d="M17.5781 20.9607C18.2681 20.8107 18.9198 20.5207 19.4565 20.0907C20.9515 18.9207 20.9515 16.9907 19.4565 15.8207C18.9294 15.4007 18.2873 15.1207 17.6069 14.9607"
  //         stroke="#1C485F"
  //         stroke-width="1.5"
  //         stroke-linecap="round"
  //         stroke-linejoin="round"
  //       />
  //     </svg>
  //   ),
  // },
  // {
  //   id: 4,
  //   text: "About",
  //   svg: (
  //     <svg
  //       xmlns="http://www.w3.org/2000/svg"
  //       width="22"
  //       height="20"
  //       viewBox="0 0 24 25"
  //       fill="none"
  //     >
  //       <path
  //         d="M17.25 11.1407V13.7707C17.25 13.9407 17.24 14.1007 17.22 14.2607C17.07 16.0307 16.02 16.9107 14.1 16.9107H13.84C13.68 16.9107 13.52 16.9907 13.42 17.1207L12.63 18.1707C12.28 18.6407 11.72 18.6407 11.37 18.1707L10.58 17.1207C10.49 17.0107 10.3 16.9107 10.16 16.9107H9.89999C7.79999 16.9107 6.75 16.3907 6.75 13.7607V11.1307C6.75 9.21074 7.63999 8.16071 9.39999 8.01071C9.55999 7.99071 9.72001 7.98071 9.89001 7.98071H14.09C16.2 8.00071 17.25 9.05072 17.25 11.1407Z"
  //         stroke="#727272"
  //         stroke-width="1.5"
  //         stroke-miterlimit="10"
  //         stroke-linecap="round"
  //         stroke-linejoin="round"
  //       />
  //       <path
  //         d="M12 22.9607C17.5228 22.9607 22 18.4835 22 12.9607C22 7.43785 17.5228 2.96069 12 2.96069C6.47715 2.96069 2 7.43785 2 12.9607C2 18.4835 6.47715 22.9607 12 22.9607Z"
  //         stroke="#727272"
  //         stroke-width="1.5"
  //         stroke-miterlimit="10"
  //         stroke-linecap="round"
  //         stroke-linejoin="round"
  //       />
  //     </svg>
  //   ),
  //   activeSvg: (
  //     <svg
  //       xmlns="http://www.w3.org/2000/svg"
  //       width="22"
  //       height="20"
  //       viewBox="0 0 24 25"
  //       fill="none"
  //     >
  //       <path
  //         d="M17.25 11.1407V13.7707C17.25 13.9407 17.24 14.1007 17.22 14.2607C17.07 16.0307 16.02 16.9107 14.1 16.9107H13.84C13.68 16.9107 13.52 16.9907 13.42 17.1207L12.63 18.1707C12.28 18.6407 11.72 18.6407 11.37 18.1707L10.58 17.1207C10.49 17.0107 10.3 16.9107 10.16 16.9107H9.89999C7.79999 16.9107 6.75 16.3907 6.75 13.7607V11.1307C6.75 9.21074 7.63999 8.16071 9.39999 8.01071C9.55999 7.99071 9.72001 7.98071 9.89001 7.98071H14.09C16.2 8.00071 17.25 9.05072 17.25 11.1407Z"
  //         stroke="#1C485F"
  //         stroke-width="1.5"
  //         stroke-miterlimit="10"
  //         stroke-linecap="round"
  //         stroke-linejoin="round"
  //       />
  //       <path
  //         d="M12 22.9607C17.5228 22.9607 22 18.4835 22 12.9607C22 7.43785 17.5228 2.96069 12 2.96069C6.47715 2.96069 2 7.43785 2 12.9607C2 18.4835 6.47715 22.9607 12 22.9607Z"
  //         stroke="#1C485F"
  //         stroke-width="1.5"
  //         stroke-miterlimit="10"
  //         stroke-linecap="round"
  //         stroke-linejoin="round"
  //       />
  //     </svg>
  //   ),
  // },
];

const filters = [
  {
    id: 1,
    text: "Last 7 days",
  },
  // {
  //   id: 2,
  //   text: "Month to date",
  // },
  {
    id: 3,
    text: "Last 3 Weeks",
  },
  {
    id: 4,
    text: "Last 4 Weeks",
  },

  {
    id: 6,
    text: "Last 6 Weeks",
  },
];

const recordsTitleData = [
  {
    id: 1,
    name: "CAMPAIGN NAME",
  },
  {
    id: 2,
    name: "SENT",
  },
  {
    id: 3,
    name: "OPENED",
  },
  {
    id: 4,
    name: "CLICKED",
  },
  {
    id: 5,
    name: "REPLIED",
  },
];

const recordsData = [
  {
    id: 1,
    name: "My campaign name",
    value: "11 hours ago",
    svg: false,
  },
  {
    id: 2,
    name: "My campaign name",
    value: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 25 25"
        fill="none"
      >
        <path
          d="M21.7546 18.8007L20.1246 19.3507C19.6746 19.5007 19.3146 19.8507 19.1646 20.3107L18.6146 21.9407C18.1446 23.3507 16.1646 23.3207 15.7246 21.9107L13.8746 15.9607C13.5146 14.7807 14.6046 13.6807 15.7746 14.0507L21.7346 15.9007C23.1346 16.3407 23.1546 18.3307 21.7546 18.8007Z"
          stroke="#868686"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M22.7969 12.9607C22.7969 7.44069 18.3169 2.96069 12.7969 2.96069C7.27688 2.96069 2.79688 7.44069 2.79688 12.9607C2.79688 18.4807 7.27688 22.9607 12.7969 22.9607"
          stroke="#868686"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    ),
    svg: true,
    number: 0,
  },
  {
    id: 3,
    name: "My campaign name",
    value: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 25 25"
        fill="none"
      >
        <path
          d="M7.60156 12.9607C3.60156 12.9607 3.60156 14.7507 3.60156 16.9607V17.9607C3.60156 20.7207 3.60156 22.9607 8.60156 22.9607H16.6016C20.6016 22.9607 21.6016 20.7207 21.6016 17.9607V16.9607C21.6016 14.7507 21.6016 12.9607 17.6016 12.9607C16.6016 12.9607 16.3216 13.1707 15.8016 13.5607L14.7816 14.6407C13.6016 15.9007 11.6016 15.9007 10.4116 14.6407L9.40156 13.5607C8.88156 13.1707 8.60156 12.9607 7.60156 12.9607Z"
          stroke="#868686"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M19.6016 12.9607V6.96069C19.6016 4.75069 19.6016 2.96069 15.6016 2.96069H9.60156C5.60156 2.96069 5.60156 4.75069 5.60156 6.96069V12.9607"
          stroke="#868686"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    ),
    svg: true,
    number: 0,
  },
  {
    id: 4,
    name: "My campaign name",
    value: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 25 25"
        fill="none"
      >
        <path
          d="M12.4 15.8407C11.49 15.8407 10.75 15.1007 10.75 14.1907V11.7207C10.75 10.8107 11.49 10.0707 12.4 10.0707C13.31 10.0707 14.05 10.8107 14.05 11.7207V14.1907C14.05 15.1007 13.31 15.8407 12.4 15.8407Z"
          stroke="#868686"
          stroke-width="1.5"
          stroke-linecap="round"
        />
        <path
          d="M17.3784 14.4307C17.1784 17.0107 15.0184 19.0307 12.3984 19.0307C9.63844 19.0307 7.39844 16.7907 7.39844 14.0307V11.8907C7.39844 9.13069 9.63844 6.89069 12.3984 6.89069C14.9884 6.89069 17.1184 8.86068 17.3684 11.3807"
          stroke="#868686"
          stroke-width="1.5"
          stroke-linecap="round"
        />
        <path
          d="M15.3984 2.96069H17.3984C20.3984 2.96069 22.3984 4.96069 22.3984 7.96069V9.96069"
          stroke="#868686"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M2.39844 9.96069V7.96069C2.39844 4.96069 4.39844 2.96069 7.39844 2.96069H9.39844"
          stroke="#868686"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M15.3984 22.9607H17.3984C20.3984 22.9607 22.3984 20.9607 22.3984 17.9607V15.9607"
          stroke="#868686"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M2.39844 15.9607V17.9607C2.39844 20.9607 4.39844 22.9607 7.39844 22.9607H9.39844"
          stroke="#868686"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    ),
    svg: true,
    number: 0,
  },
  {
    id: 5,
    name: "My campaign name",
    value: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 25 25"
        fill="none"
      >
        <path
          d="M10.5109 14.653L15.357 9.80689M20.3144 6.84937L16.2238 20.144C15.8572 21.3354 15.6738 21.9314 15.3576 22.1289C15.0833 22.3003 14.7438 22.3289 14.4451 22.205C14.1007 22.0621 13.8211 21.504 13.2635 20.3887L10.6725 15.2068C10.584 15.0298 10.5397 14.9417 10.4806 14.865C10.4282 14.7969 10.3676 14.7356 10.2996 14.6832C10.2246 14.6254 10.138 14.5821 9.9689 14.4976L4.77505 11.9006C3.65974 11.343 3.10204 11.0639 2.95913 10.7195C2.83519 10.4208 2.86346 10.0809 3.03481 9.80667C3.2324 9.49043 3.82836 9.30672 5.02017 8.94001L18.3148 4.84937C19.2517 4.56107 19.7204 4.41704 20.0369 4.53322C20.3125 4.63442 20.5298 4.85153 20.631 5.1272C20.7472 5.44352 20.603 5.91196 20.315 6.84798L20.3144 6.84937Z"
          stroke="#868686"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    ),
    svg: true,
    number: 0,
  },
];

const Statistics = () => {
  const [activeFilterBtn, setActiveFilterBtn] = useState(0);
  const history = useHistory();
  const userDetails = JSON.parse(localStorage.getItem("MailSenderuserDetails"));
  const locData = useLocation();
  const [activeOption, setActiveOption] = useState("Statistics");
  const [label, setLabel] = useState([]);
  const [dataBar, setDataBar] = useState([]);
  const [dataLine1, setDataLine1] = useState([]);
  const [dataLine2, setDataLine2] = useState([]);
  const [campaignDetails, setCampaignDetails] = useState("");
  const [loader, setLoader] = useState(true);
  const [value, setValue] = useState([null, null]);
  const [showToaster, setShowToaster] = useState(false);
  const [pauseLoader, setpauseLoader] = useState(false);
  const [campaignStatus, setCampaignStatus] = useState("");
  const [updateComponentUi, setUpdateComponentUi] = useState(false);
  const [chartData, setChartData] = useState([
    {
      id: 1,
      name: "Total email sent",
      value: "12,721",
    },
    {
      id: 2,
      name: "Average open rate",
      value: "721",
    },
    {
      id: 3,
      name: "Total Recipient clicks",
      value: "12,721",
    },
    // {
    //   id: 4,
    //   name: "Total subscribes",
    //   value: "12,721",
    // },
    // {
    //   id: 5,
    //   name: "Total Unsubscribes",
    //   value: "12,721",
    // },
  ]);
  const monthShort = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  function getCampaignByid(
    selected,
    sDate,
    sMonth,
    sYear,
    eDate,
    eMonth,
    eYear
  ) {
    let campData = {
      weeks: selected,
      startDate: sDate,
      startMonth: sMonth,
      startYear: sYear,
      endDate: eDate,
      endMonth: eMonth,
      endYear: eYear,
      dayCount: selected * 7,
    };
    axios
      .put(
        `${BaseUrl.baseurl}/email-marketing/automation/get-user-campaign/${
          userDetails && userDetails.details._id
        }/${locData.state._id}`,
        campData,
        {
          headers: {
            Authorization: `Bearear ${userDetails && userDetails.token}`,
          },
        }
      )
      .then((response) => {
        if (response.data.status) {
          setCampaignDetails(response.data);
          setCampaignStatus(response.data.campaignStatus);
          chartData.map((val, idx) => {
            if (idx === 0) {
              val.count = response.data.totalEmailSent;
            } else if (idx === 1) {
              val.count = `${parseInt(response.data.averageCampaignOpened)}%`;
            } else if (idx === 2) {
              val.count = response.data.totalCampaignClicked;
            } else if (idx === 3) {
              val.count = response.data.totalCampaignSubscription;
            } else if (idx === 4) {
              val.count = response.data.totalCampaignUnsubscription;
            }
          });
          setChartData([...chartData]);
          let label = [];
          let bar = [];
          let line1 = [];
          let line2 = [];
          response.data.graphDetails.map((val) => {
            if (selected !== 1) {
              label.push(`${val.Date} ${monthShort[val.Month - 1]}`);
            } else {
              label.push(val.DayName);
            }

            bar.push(val.Details.SentCount);
            line1.push(val.Details.InboxCount);
            line2.push(val.Details.SpamCount);
          });
          setLabel(label);
          setDataBar(bar);
          setDataLine1(line1);
          setDataLine2(line2);

          setLoader(false);
        } else {
          if (response.data.tokenExpire) {
            localStorage.removeItem("MailSenderuserDetails");
            window.location.reload();
          }
        }
        setLoader(false);
      })
      .catch((err) => console.log("Error"));
  }
  const [logs, setLogs] = useState("");
  function getIss() {
    axios
      .get(
        `${BaseUrl.baseurl}/email-marketing/automation/get-campaign-logs/${
          userDetails && userDetails.details._id
        }/${locData.state._id}`,
        {
          headers: {
            Authorization: `Bearear ${userDetails && userDetails.token}`,
          },
        }
      )
      .then((response) => {
        setLogs(response.data);
      })
      .catch((err) => console.log("Error"));
  }
  useEffect(() => {
    getIss();
    getCampaignByid(1, 0, 0, 0, 0, 0, 0);
  }, [updateComponentUi]);

  function convertDatetoExactFormat(dateString) {
    const date = new Date(dateString);

    const options = {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    };

    const formattedDate = date.toLocaleString("en-US", options);

    return formattedDate;
  }
  const today = new Date(); // Get the current date
  const originalDate = new Date(locData.state.createdAt);
  originalDate.setDate(originalDate.getDate());
  const formattedDate = originalDate.toISOString().split("T")[0];
  const endDateToDisable = new Date(formattedDate); // Replace with your desired end date
  console.log("getting loc data", locData.state);

  const disabledDate = (date) => {
    // Disable dates in the future from today
    if (locData.state.Duration.Status) {
      const originalDate2 = new Date(locData.state.Duration.EndDate);
      originalDate2.setDate(originalDate2.getDate() + 1);
      const formattedDate2 = originalDate2.toISOString().split("T")[0];
      const endDateToDisable2 = new Date(formattedDate2);
      if (date.getTime() > endDateToDisable2.getTime()) {
        return true;
      }
    }

    // Disable dates in the past before a given end date
    if (date.getTime() < endDateToDisable.getTime()) {
      return true;
    }
    return false;
  };
  const dateRangePickerRef = useRef();
  useEffect(() => {
    if (dateRangePickerRef.current) {
      const handleChange = () => {
        const selectedDates = dateRangePickerRef.current.value;
        console.log("selected date", selectedDates);
      };

      dateRangePickerRef.current.onChange = handleChange;
    }
  }, [dateRangePickerRef]);
  function getCustomAnalytics(dateRange) {
    let start = new Date(dateRange[0]);
    let end = new Date(dateRange[1]);
    getCampaignByid(
      0,
      start.getDate(),
      start.getMonth() + 1,
      start.getFullYear(),
      end.getDate(),
      end.getMonth() + 1,
      end.getFullYear()
    );
    setValue(dateRange);
    // getWarmupAnalytic(0, , new Date(dateRange[1]), true);
  }
  function runPendingCampaign(campId) {
    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${
        BaseUrl.baseurl
      }/email-marketing/automation/check-run-automation-campaign/${
        userDetails && userDetails.details._id
      }/${campId}`,
      headers: {
        Authorization: `Bearear ${userDetails && userDetails.token}`,
      },
    };

    axios
      .request(config)
      .then((response) => {
        if (response.data.status) {
          setUpdateComponentUi(!updateComponentUi);
          setShowToaster(true);
          toast.success(response.data.message, {
            autoClose: true,
            position: "top-right",
            duration: 3000,
          });
        } else {
          setShowToaster(true);
          setUpdateComponentUi(!updateComponentUi);
          toast.error(response.data.message, {
            autoClose: true,
            position: "top-right",
            duration: 3000,
          });
          if (response.data.tokenExpire) {
            localStorage.removeItem("MailSenderuserDetails");
            window.location.reload();
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }
  function pauseOngoingCampaign(campId) {
    setpauseLoader(true);
    let config = {
      method: "put",
      maxBodyLength: Infinity,
      url: `${BaseUrl.baseurl}/email-marketing/automation/pause-user-campaign/${
        userDetails && userDetails.details._id
      }/${campId}`,
      headers: {
        Authorization: `Bearear ${userDetails && userDetails.token}`,
      },
    };

    axios
      .request(config)
      .then((response) => {
        if (response.data.status) {
          setUpdateComponentUi(!updateComponentUi);
          setShowToaster(true);
          toast.success(response.data.message, {
            autoClose: true,
            position: "top-right",
            duration: 3000,
          });
        } else {
          setUpdateComponentUi(!updateComponentUi);
          setShowToaster(true);
          toast.error(response.data.message, {
            autoClose: true,
            position: "top-right",
            duration: 3000,
          });
          if (response.data.tokenExpire) {
            localStorage.removeItem("MailSenderuserDetails");
            window.location.reload();
          }
        }
        setpauseLoader(false);
      })
      .catch((error) => {
        console.log(error);
      });
  }
  function resumePausedCampaign(campId) {
    let config = {
      method: "put",
      maxBodyLength: Infinity,
      url: `${
        BaseUrl.baseurl
      }/email-marketing/automation/resume-user-campaign/${
        userDetails && userDetails.details._id
      }/${campId}`,
      headers: {
        Authorization: `Bearear ${userDetails && userDetails.token}`,
      },
    };

    axios
      .request(config)
      .then((response) => {
        if (response.data.status) {
          setUpdateComponentUi(!updateComponentUi);
          setShowToaster(true);
          toast.success(response.data.message, {
            autoClose: true,
            position: "top-right",
            duration: 3000,
          });
        } else {
          setUpdateComponentUi(!updateComponentUi);
          setShowToaster(true);
          toast.error(response.data.message, {
            autoClose: true,
            position: "top-right",
            duration: 3000,
          });
          if (response.data.tokenExpire) {
            localStorage.removeItem("MailSenderuserDetails");
            window.location.reload();
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }
  const headCells = [
    {
      id: 1,
      label: "Email",
    },
    {
      id: 2,
      label: "Console Tittle",
    },
    {
      id: 2,
      label: "Console Message",
    },
  ];
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  return (
    <div
      style={{
        height: "100%",
        overflow: "auto",
        borderRadius: "5px",
        backgroundColor: "#FFF",
        border: "1px solid #DDD",
      }}
    >
      {loader ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "40vh",
            padding: "30px",
          }}
        >
          <Loader />
        </div>
      ) : (
        <Box>
          <Box
            sx={{
              backgroundColor: "#fff",
              width: "100%",
              padding: "0px 0px 14px 0px",
            }}
          >
            <Box sx={{ borderBottomWidth: "1px", position: "relative" }}>
              <div
                style={{
                  display: "flex",
                  padding: "5px 16px",
                  position: "relative",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexGrow: 1,
                    gap: "25px",
                    position: "relative",
                  }}
                >
                  {multipleOptions.map((option, i) => (
                    <button
                      key={option.id}
                      onClick={() => {
                        setActiveOption(option.text);
                        history.push("/DashBoard/Campaign");
                      }}
                      style={{
                        fontFamily: " Source Sans 3",
                        fontStyle: "normal",
                        color:
                          activeOption === option.text ? "#1C485F" : "#727272",
                        fontSize: "20px",
                        fontWeight: 700,
                        display: "flex",
                        justifyContent: "space-between",
                        outline: "none",
                        alignItems: "center",
                        gap: "4px",
                        borderBottom:
                          activeOption === option.text
                            ? "2px solid #1C485F"
                            : "2px solid #fff",
                      }}
                    >
                      <ArrowBackIcon />
                      {option.text}
                    </button>
                  ))}
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 16,
                    position: "relative",
                    zIndex: 100,
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "flex-end",
                      alignItems: "center",
                      padding: "8px 16px",
                    }}
                  >
                    {/* <div>
              <h1
                style={{
                  fontFamily: " Source Sans 3",
                  fontStyle: "normal",
                  color: "#393939",
                  fontSize: "20px",
                  fontWeight: 700,
                }}
              >
                Campaigns
              </h1>
            </div> */}
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: "20px",
                      }}
                    >
                      {/* <div
                style={{
                  backgroundColor: "#e9f7e9",
                  borderRadius: "25px",
                  padding: "3px 10px",
                  display: "flex",
                  alignItems: "center",
                  gap: "5px",
                  height: "max-content",
                }}
              >
                <div
                  style={{
                    height: "10px",
                    width: "10px",
                    borderRadius: "100%",
                    backgroundColor: "#53D86A",
                  }}
                ></div>
                <div
                  style={{
                    fontFamily: " Source Sans 3",
                    fontStyle: "normal",
                    color: "#53D86A",
                    fontSize: "14px",
                    fontWeight: 400,
                  }}
                >
                  Active
                </div>
              </div> */}
                      {campaignStatus === "Paused" ? (
                        <div className="pausedstatusbutton">Paused</div>
                      ) : campaignStatus === "Ongoing" ? (
                        <div className="ongoingstatusbuttton">Ongoing</div>
                      ) : campaignStatus === "Terminated" ? (
                        <div className="terminatedstatusbutton">Terminated</div>
                      ) : campaignStatus === "Completed" ? (
                        <div className="Completedstatusbutton">Completed</div>
                      ) : (
                        (campaignStatus === "Pending" ||
                          campaignStatus === "Schedule") && (
                          <div className="pendingstatusbutton">
                            {campaignStatus}
                          </div>
                        )
                      )}
                      {pauseLoader ? (
                        <CircularProgress size={20} sx={{ color: "#1C485F" }} />
                      ) : (
                        <div
                          className="campaignmailrightside"
                          style={{
                            marginLeft: "12px",
                            pointerEvents:
                              (campaignStatus === "Terminated" ||
                                campaignStatus === "Completed" ||
                                campaignStatus === "Schedule") &&
                              "none",
                            opacity:
                              (campaignStatus === "Terminated" ||
                                campaignStatus === "Completed" ||
                                campaignStatus === "Schedule") &&
                              0.5,
                          }}
                        >
                          {campaignStatus === "Ongoing" ? (
                            <Tooltip title="Pause" arrow>
                              <div
                                style={{
                                  display: "flex",
                                  gap: "3px",
                                  alignItems: "center",
                                }}
                                onClick={() => {
                                  // setSelectedCampaignId(val.campaignDetails);
                                  pauseOngoingCampaign(locData.state._id);
                                }}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="25"
                                  height="24"
                                  viewBox="0 0 25 24"
                                  fill="none"
                                >
                                  <path
                                    d="M12.6836 22C18.2064 22 22.6836 17.5228 22.6836 12C22.6836 6.47715 18.2064 2 12.6836 2C7.16075 2 2.68359 6.47715 2.68359 12C2.68359 17.5228 7.16075 22 12.6836 22Z"
                                    stroke="#1C485F"
                                    stroke-width="1.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                  <path
                                    d="M11.4339 14.53V9.47005C11.4339 8.99005 11.2339 8.80005 10.7239 8.80005H9.42387C8.91387 8.80005 8.71387 8.99005 8.71387 9.47005V14.53C8.71387 15.01 8.91387 15.2 9.42387 15.2H10.7139C11.2339 15.2 11.4339 15.01 11.4339 14.53Z"
                                    stroke="#1C485F"
                                    stroke-width="1.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                  <path
                                    d="M16.7139 14.53V9.47005C16.7139 8.99005 16.5139 8.80005 16.0039 8.80005H14.7139C14.2039 8.80005 14.0039 8.99005 14.0039 9.47005V14.53C14.0039 15.01 14.2039 15.2 14.7139 15.2H16.0039C16.5139 15.2 16.7139 15.01 16.7139 14.53Z"
                                    stroke="#1C485F"
                                    stroke-width="1.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                </svg>
                                Pause
                              </div>
                            </Tooltip>
                          ) : (
                            <Tooltip title="Resume" arrow>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "4px",
                                }}
                                onClick={() => {
                                  if (campaignStatus === "Paused") {
                                    resumePausedCampaign(locData.state._id);
                                  } else {
                                    runPendingCampaign(locData.state._id);
                                  }
                                }}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="25"
                                  height="24"
                                  viewBox="0 0 25 24"
                                  fill="none"
                                >
                                  <path
                                    d="M12.6846 22C18.2074 22 22.6846 17.5228 22.6846 12C22.6846 6.47715 18.2074 2 12.6846 2C7.16172 2 2.68457 6.47715 2.68457 12C2.68457 17.5228 7.16172 22 12.6846 22Z"
                                    stroke="#868686"
                                    stroke-width="1.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                  <path
                                    d="M9.45459 12.23V10.56C9.45459 8.48 10.9246 7.63 12.7246 8.67L14.1746 9.51L15.6246 10.35C17.4246 11.39 17.4246 13.09 15.6246 14.13L14.1746 14.97L12.7246 15.81C10.9246 16.85 9.45459 16 9.45459 13.92V12.23Z"
                                    stroke="#868686"
                                    stroke-width="1.5"
                                    stroke-miterlimit="10"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                </svg>
                                Resume
                              </div>
                            </Tooltip>
                          )}
                        </div>
                      )}

                      {actionsArr.map((data, idx) => (
                        <button
                          onClick={() => {
                            if (idx === 0) {
                              history.push("/All-Campaign/New-Campaign", {
                                campaignName: locData.state.Name,
                                from: "edit",
                                campaignData: locData.state.CampaignCopy,
                              });
                            } else {
                            }
                          }}
                          key={data.id}
                          style={{
                            display: "flex",
                            gap: "6px",
                            alignItems: "center",
                            fontFamily: " Source Sans 3",
                            fontStyle: "normal",
                            color: "#393939",
                            fontSize: "14px",
                            outline: "none",
                            pointerEvents:
                              campaignStatus === "Completed" && "none",
                            opacity: campaignStatus === "Completed" && 0.5,
                          }}
                        >
                          {data.svg}
                          {data.text}
                        </button>
                      ))}
                    </div>
                  </Box>
                  {/* <DateRangePicker
                    value={value}
                    ref={dateRangePickerRef}
                    disabledDate={disabledDate}
                    showOneCalendar
                    placeholder="Custom range"
                    placement="bottomEnd"
                    size="md"
                    onOk={(e) => {
                      getCustomAnalytics(e);
                    }}
                    ranges={[]}
                  /> */}
                </div>
              </div>
            </Box>
            <Box sx={{ padding: "8px 16px" }}>
              <Box sx={{ backgroundColor: "#fff" }}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <h1
                    style={{
                      fontFamily: " Source Sans 3",
                      fontStyle: "normal",
                      color: "#000000",
                      fontSize: "14px",
                      fontWeight: 400,
                    }}
                  >
                    Email open rate vs unique open rate by campaign
                  </h1>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "25px",
                    }}
                  >
                    {filters.map((option, i) => (
                      <button
                        onClick={() => {
                          getCampaignByid(option.id, 0, 0, 0, 0, 0, 0);

                          setActiveFilterBtn(i);
                        }}
                        key={option.id}
                        style={{
                          fontFamily: " Source Sans 3",
                          fontStyle: "normal",
                          color: activeFilterBtn === i ? "#fff" : "#000",
                          fontSize: "12px",
                          fontWeight: 400,
                          outline: "none",
                          backgroundColor:
                            activeFilterBtn === i ? "#FF3301" : "#F3F3F3",
                          borderRadius: "4px",
                          padding: "6px 12px",
                        }}
                      >
                        {option.text}
                      </button>
                    ))}
                  </div>
                </div>
              </Box>
            </Box>
            <div style={{ padding: "20px 40px" }}>
              <StackedChart
                label={label}
                dataBar={dataBar}
                dataLine1={dataLine1}
                dataLine2={dataLine2}
              />
            </div>
            <Box
              sx={{
                borderTopWidth: "1px",
                padding: "0px 16px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              {chartData.map((data) => (
                <>
                  <div
                    key={data.id}
                    className={`${chartData.length}`}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      flexDirection: "column",
                      alignItems: "center",
                      width: "20%",
                      padding: "15px 48px",
                      alignSelf: "stretch",
                    }}
                  >
                    <div
                      style={{
                        fontFamily: " Source Sans 3",
                        fontStyle: "normal",
                        color: "var(--color-black, #000)",
                        fontSize: "14px",
                        fontWeight: 700,
                        lineHeight: "24px",
                      }}
                    >
                      {data.count}
                    </div>
                    <div
                      style={{
                        fontFamily: " Source Sans 3",
                        fontStyle: "normal",
                        color: "var(--color-dark-500, #868686)",
                        fontSize: "14px",
                        fontWeight: 400,
                        lineHeight: "20px",
                      }}
                    >
                      {data.name}
                    </div>
                  </div>
                </>
              ))}
            </Box>
            <Box
              sx={{
                padding: "0px 16px",
                margin: "4px 0px",
                display: "flex",
                flexDirection: "column",
                gap: "10px",
              }}
            >
              <Box
                sx={{
                  backgroundColor: "#FAFAFA",
                  padding: "10px 16px",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  borderRadius: "10px",
                }}
              >
                {recordsTitleData.map((data) => (
                  <>
                    <div key={data.id} style={{ width: "20%" }}>
                      <p
                        className="tracking-wide"
                        style={{
                          fontFamily: " Source Sans 3",
                          fontStyle: "normal",
                          color: "#000000",
                          fontSize: "12px",
                          fontWeight: 700,
                        }}
                      >
                        {data.name}
                      </p>
                    </div>
                  </>
                ))}
              </Box>

              <Box
                sx={{
                  backgroundColor: "#FAFAFA",
                  padding: "0px 16px",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  borderRadius: "6px",
                }}
              >
                <div style={{ width: "100%" }}>
                  <div
                    className="campaignmaildetails"
                    style={{ width: "100%" }}
                  >
                    <div className="campaindetailsitems">
                      <div className="campaigndetailsmain">
                        {campaignDetails.campaignName}
                      </div>
                      <div className="campaigndetailssub">
                        {convertDatetoExactFormat(
                          campaignDetails.CampaignCreatedDate
                        )}
                      </div>
                    </div>
                    <div className="campaignmaildetailsiconnumber">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="25"
                        height="25"
                        viewBox="0 0 25 25"
                        fill="none"
                      >
                        <path
                          d="M21.2448 18.8007L19.6148 19.3507C19.1648 19.5007 18.8048 19.8507 18.6548 20.3107L18.1048 21.9407C17.6348 23.3507 15.6548 23.3207 15.2148 21.9107L13.3648 15.9607C13.0048 14.7807 14.0948 13.6807 15.2648 14.0507L21.2248 15.9007C22.6248 16.3407 22.6448 18.3307 21.2448 18.8007Z"
                          stroke="#868686"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M22.2852 12.9607C22.2852 7.44069 17.8052 2.96069 12.2852 2.96069C6.76516 2.96069 2.28516 7.44069 2.28516 12.9607C2.28516 18.4807 6.76516 22.9607 12.2852 22.9607"
                          stroke="#868686"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                      {campaignDetails && campaignDetails.totalEmailSent}
                    </div>
                    <div className="campaignmaildetailsiconnumber">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="25"
                        height="24"
                        viewBox="0 0 25 24"
                        fill="none"
                      >
                        <path
                          d="M7.57129 12C3.57129 12 3.57129 13.79 3.57129 16V17C3.57129 19.76 3.57129 22 8.57129 22H16.5713C20.5713 22 21.5713 19.76 21.5713 17V16C21.5713 13.79 21.5713 12 17.5713 12C16.5713 12 16.2913 12.21 15.7713 12.6L14.7513 13.68C13.5713 14.94 11.5713 14.94 10.3813 13.68L9.37129 12.6C8.85129 12.21 8.57129 12 7.57129 12Z"
                          stroke="#868686"
                          stroke-width="1.5"
                          stroke-miterlimit="10"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M19.5713 12V6C19.5713 3.79 19.5713 2 15.5713 2H9.57129C5.57129 2 5.57129 3.79 5.57129 6V12"
                          stroke="#868686"
                          stroke-width="1.5"
                          stroke-miterlimit="10"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                      {campaignDetails && campaignDetails.totalCampaignOpened}
                    </div>
                    <div className="campaignmaildetailsiconnumber">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="25"
                        height="24"
                        viewBox="0 0 25 24"
                        fill="none"
                      >
                        <path
                          d="M12.857 14.88C11.947 14.88 11.207 14.14 11.207 13.23V10.76C11.207 9.85001 11.947 9.10999 12.857 9.10999C13.767 9.10999 14.507 9.85001 14.507 10.76V13.23C14.507 14.14 13.767 14.88 12.857 14.88Z"
                          stroke="#868686"
                          stroke-width="1.5"
                          stroke-linecap="round"
                        />
                        <path
                          d="M17.8369 13.47C17.6369 16.05 15.4769 18.07 12.8569 18.07C10.0969 18.07 7.85693 15.83 7.85693 13.07V10.93C7.85693 8.16999 10.0969 5.92999 12.8569 5.92999C15.4469 5.92999 17.5769 7.89998 17.8269 10.42"
                          stroke="#868686"
                          stroke-width="1.5"
                          stroke-linecap="round"
                        />
                        <path
                          d="M15.8569 2H17.8569C20.8569 2 22.8569 4 22.8569 7V9"
                          stroke="#868686"
                          stroke-width="1.5"
                          stroke-miterlimit="10"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M2.85693 9V7C2.85693 4 4.85693 2 7.85693 2H9.85693"
                          stroke="#868686"
                          stroke-width="1.5"
                          stroke-miterlimit="10"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M15.8569 22H17.8569C20.8569 22 22.8569 20 22.8569 17V15"
                          stroke="#868686"
                          stroke-width="1.5"
                          stroke-miterlimit="10"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M2.85693 15V17C2.85693 20 4.85693 22 7.85693 22H9.85693"
                          stroke="#868686"
                          stroke-width="1.5"
                          stroke-miterlimit="10"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                      {`${
                        campaignDetails && campaignDetails.totalCampaignClicked
                      } `}
                    </div>
                    <div className="campaignmaildetailsiconnumber">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="25"
                        height="24"
                        viewBox="0 0 25 24"
                        fill="none"
                      >
                        <path
                          d="M10.4503 13.6923L15.2965 8.84619M20.2539 5.88867L16.1632 19.1833C15.7966 20.3747 15.6132 20.9707 15.297 21.1683C15.0228 21.3396 14.6832 21.3683 14.3845 21.2443C14.0401 21.1014 13.7606 20.5433 13.2029 19.428L10.612 14.2461C10.5235 14.0691 10.4792 13.981 10.4201 13.9043C10.3676 13.8363 10.3071 13.7749 10.239 13.7225C10.1641 13.6647 10.0774 13.6214 9.90835 13.5369L4.7145 10.9399C3.5992 10.3823 3.04149 10.1032 2.89858 9.75879C2.77465 9.4601 2.80291 9.12023 2.97427 8.84597C3.17185 8.52974 3.76781 8.34603 4.95962 7.97932L18.2542 3.88867C19.1912 3.60038 19.6598 3.45635 19.9763 3.57253C20.252 3.67373 20.4693 3.89084 20.5705 4.16651C20.6866 4.48283 20.5425 4.95126 20.2545 5.88729L20.2539 5.88867Z"
                          stroke="#868686"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                      {campaignDetails && campaignDetails.totalEmailReply}
                    </div>
                  </div>
                </div>
                {/* {recordsData.map((data) => (
              <>
                <div
                  key={data.id}
                  style={{ width: "20%", padding: "10px 0px" }}
                >
                  <div
                    className={`flex ${
                      data.id === 1
                        ? "flex-col-reverse"
                        : "flex-row items-center gap-2"
                    }  `}
                  >
                    <p
                      style={{
                        fontFamily: " Source Sans 3",
                        fontStyle: "normal",
                        color: "#868686",
                        fontSize: "12px",
                        fontWeight: 400,
                      }}
                    >
                      {data.value}
                    </p>
                    {data.svg ? (
                      <p
                        className="tracking-wide"
                        style={{
                          fontFamily: " Source Sans 3",
                          fontStyle: "normal",
                          color: "#868686",
                          fontSize: "14px",
                          fontWeight: 400,
                        }}
                      >
                        {data.number}
                      </p>
                    ) : (
                      <p
                        className="tracking-wide"
                        style={{
                          fontFamily: " Source Sans 3",
                          fontStyle: "normal",
                          color: "#868686",
                          fontSize: "14px",
                          fontWeight: 700,
                        }}
                      >
                        {data.name}
                      </p>
                    )}
                  </div>
                </div>
              </>
            ))} */}
              </Box>
            </Box>
            {logs && logs.nodeDetails?.length !== 0 && (
              <div className="p-pad-20 flex flex-col gap-2">
                <div className="text-sm font-bold text-black ">
                  EMAIL NODE WISE STATISTICS
                </div>
                <div className="grid grid-cols-2 gap-3">
                  {logs?.nodeDetails.map((val, key) => {
                    return (
                      <div
                        style={{
                          backgroundColor: "#FAFAFA",
                          padding: "10px 16px",
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          borderRadius: "10px",
                          gap: "12px",
                        }}
                      >
                        <div className="campaigndetailsmain">
                          Email {key + 1}
                        </div>
                        <div className="grid grid-cols-3 gap-4">
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              flexDirection: "column",
                              alignItems: "center",
                            }}
                          >
                            <div
                              style={{
                                fontFamily: " Source Sans 3",
                                fontStyle: "normal",
                                color: "var(--color-dark-500, #868686)",
                                fontSize: "14px",
                                fontWeight: 400,
                                lineHeight: "20px",
                              }}
                            >
                              Total Sent A Email
                            </div>
                            <div
                              style={{
                                fontFamily: " Source Sans 3",
                                fontStyle: "normal",
                                color: "var(--color-black, #000)",
                                fontSize: "14px",
                                fontWeight: 700,
                                lineHeight: "24px",
                              }}
                            >
                              {
                                val.StrategyEmailList.filter(
                                  (str) =>
                                    str.Sent === true && str.Strategy === "A"
                                ).length
                              }
                            </div>
                          </div>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              flexDirection: "column",
                              alignItems: "center",
                            }}
                          >
                            <div
                              style={{
                                fontFamily: " Source Sans 3",
                                fontStyle: "normal",
                                color: "var(--color-dark-500, #868686)",
                                fontSize: "14px",
                                fontWeight: 400,
                                lineHeight: "20px",
                              }}
                            >
                              Total Sent B Email
                            </div>
                            <div
                              style={{
                                fontFamily: " Source Sans 3",
                                fontStyle: "normal",
                                color: "var(--color-black, #000)",
                                fontSize: "14px",
                                fontWeight: 700,
                                lineHeight: "24px",
                              }}
                            >
                              {
                                val.StrategyEmailList.filter(
                                  (str) =>
                                    str.Sent === true && str.Strategy === "B"
                                ).length
                              }
                            </div>
                          </div>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              flexDirection: "column",
                              alignItems: "center",
                            }}
                          >
                            <div
                              style={{
                                fontFamily: " Source Sans 3",
                                fontStyle: "normal",
                                color: "var(--color-dark-500, #868686)",
                                fontSize: "14px",
                                fontWeight: 400,
                                lineHeight: "20px",
                              }}
                            >
                              Pending Email
                            </div>
                            <div
                              style={{
                                fontFamily: " Source Sans 3",
                                fontStyle: "normal",
                                color: "var(--color-black, #000)",
                                fontSize: "14px",
                                fontWeight: 700,
                                lineHeight: "24px",
                              }}
                            >
                              {
                                val.StrategyEmailList.filter(
                                  (str) => str.Sent === false
                                ).length
                              }
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            )}
            {logs && logs.logsDetails?.length !== 0 && (
              <>
              <TableContainer>
                <Table
                  sx={{ minWidth: 750 }}
                  aria-labelledby="tableTitle"
                  size={"medium"}
                >
                 
                    <TableHead>
                      <TableRow
                        sx={{ backgroundColor: "#FAFAFA", borderRadius: "4px" }}
                      >
                        {headCells.map((headCell, index) => (
                          <TableCell
                            key={headCell.id}
                            align={
                              index === 3
                                ? "center"
                                : index === 2
                                ? "center"
                                : "left"
                            }
                          >
                            <Typography
                              variant="subtitle1"
                              fontWeight="bold"
                              fontSize={"13px"}
                            >
                              {headCell.label}
                            </Typography>
                          </TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {logs.logsDetails
                        .slice(
                          page * rowsPerPage,
                          page * rowsPerPage + rowsPerPage
                        )
                        .map((row, index) => (
                          <TableRow
                            key={row.id}
                            sx={{
                              backgroundColor:
                                index % 2 === 0 ? "#FFF" : "#FAFAFA",
                            }}
                          >
                            <TableCell align="left">
                              <p
                                style={{
                                  marginTop: "0px",
                                  fontFamily: "Source Sans 3",
                                  fontSize: "15px",
                                  fontStyle: "normal",
                                  fontWeight: 700,
                                  color: "#1C485F",
                                }}
                              >
                                {row.Details.ToEmail}
                              </p>
                            </TableCell>
                            <TableCell align="left" sx={{ color: "#868686" }}>
                              <span
                                style={{
                                  fontFamily: "Source Sans 3",
                                  fontSize: "14px",
                                  fontStyle: "normal",
                                  fontWeight: 400,
                                  color: "#868686",
                                }}
                              >
                                {row.Title}
                              </span>
                            </TableCell>
                            <TableCell align="left" sx={{ color: "#868686" }}>
                              <span
                                style={{
                                  fontFamily: "Source Sans 3",
                                  fontSize: "14px",
                                  fontStyle: "normal",
                                  fontWeight: 400,
                                  color: "#868686",
                                }}
                              >
                                {row.Message}
                              </span>
                            </TableCell>
                          </TableRow>
                        ))}
                    </TableBody>
                 
                </Table>
              </TableContainer>
             
            <div
              style={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center",
              }}
            >
              <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                component="div"
                count={logs.logsDetails.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </div>
            </>
            )}
          </Box>
        </Box>
      )}
      {showToaster && <ToastContainer />}
    </div>
  );
};

export default Statistics;
